import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
// import { EventDetailsSchema } from "../../schema";

import { AddEvent, getAllUserData } from "../../api";
import { useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { EventDetailsSchema } from "../../schema";
import ImageCropUpload from "../common/ImageCropUpload";

const initialValues = {
  // ProfileDetails
  image: null,
  name: "",
  date: "",
  time: "",
  location: "",
  members: "",
  chosenMembers: [],
  description: "",
  status: "Requested",
};

const currentDate = new Date().toISOString().split("T")[0];
const AddNewEvent = () => {
  const { token } = useSelector((state) => state.profileReducer);
  const [isLoading, setIsLoading] = useState(false);

  const toast = useRef(null);

  const addEventHandler = async (values, action) => {
    const formData = new FormData();
    formData.append("image", values.image);
    formData.append("name", values.name);
    formData.append("date", values.date);
    formData.append("time", values.time);
    formData.append("location", values.location);
    formData.append(
      "members",
      values.chosenMembers.map((ele) => ele.id).join(",")
    );
    formData.append("status", values.status);
    formData.append("description", values.description);

    await AddEvent(formData, token)
      .then((res) => {
        setIsLoading(true);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        action.resetForm();
        setTimeout(() => {
          setIsLoading(false);
          navigate("/event-management");
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    handleBlur,
    submitCount,
  } = useFormik({
    initialValues,
    validationSchema: EventDetailsSchema(),
    onSubmit: (values, action) => addEventHandler(values, action),
  });

  const getMembers = async () => {
    getAllUserData(token)
      .then((res) => {
        let arr = [];
        res?.data?.result?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.id,
            label: ele?.first_name + " " + ele?.last_name,
          })
        );
        setFieldValue("members", arr);
      })
      .catch((err) => {});
  };

  // const setInitialTime = (utcTime) => {
  //   // Convert UTC time to local time zone
  //   const [timePart, meridiem] = utcTime.split(' ');
  //   const [hours, minutes] = timePart.split(':');

  //   // Convert to 24-hour format
  //   let hourValue = Number(hours);
  //   if (meridiem.toLowerCase() === 'pm' && hourValue !== 12) {
  //     hourValue += 12;
  //   } else if (meridiem.toLowerCase() === 'am' && hourValue === 12) {
  //     hourValue = 0;
  //   }

  //   // Format the time as "HH:mm"
  //   const formattedTime = `${String(hourValue).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  // return formattedTime;
  //   // Set the formatted time in the formik state
  // };

  useEffect(() => {
    async function getAllAPI() {
      await getMembers();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  const validationMessages = Object.values(errors).filter(Boolean);

  return (
    <>
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Toast ref={toast} />
      <form onSubmit={handleSubmit} className="">
        <div className="event-details-all-starting-part mt-4 all-event-details-part-using">
          {submitCount > 0 && validationMessages.length > 0 && (
            <div className="alert alert-danger" role="alert">
              <strong>Please complete these fields:</strong>{" "}
              {validationMessages.join(", ")}
            </div>
          )}
          <div className="userprofile-pics">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="cursor-pointer"
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0">Back to Event Details</h6>
              </div>
            </div>
          </div>

          <div className="main-profile-all-cls-start mt-4">
            <div className="details-all-name upload-user-profile-cls">
              <div className="row">
                <div className="col-lg-4 position-relative">
                  <label className="my-2">
                    Upload event image:-
                    <span className="required">
                      {" "}
                      Crop will be saved as 300w X 280h
                    </span>
                  </label>
                  <ImageCropUpload
                    name="image"
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    onBlur={handleBlur}
                    error={errors.image}
                    touched={touched.image}
                  />
                  <span className="upload-all-btns-cls-add"></span>
                </div>
                <div className="col-lg-4">
                  <label className="my-2">
                    Event Name<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput2"
                    placeholder="Please Enter Event Name Here"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.name && touched.name ? (
                    <p className="form-error">{errors.name}</p>
                  ) : null}
                </div>
                <div className="col-lg-4">
                  <label className="my-2">
                    Date<span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="exampleFormControlInput2"
                    placeholder="Please Enter Title Here"
                    name="date"
                    value={values.date}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    min={currentDate}
                  />
                  {errors.date && touched.date ? (
                    <p className="form-error">{errors.date}</p>
                  ) : null}
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-lg-4">
                  <label className="my-2">
                    Time<span className="required">*</span>
                  </label>
                  <input
                    type="time"
                    // onChange={onTimeChange()}
                    // id="timeInput"
                    // step="2"
                    className="form-control"
                    id="exampleFormControlInput3"
                    placeholder="Write here"
                    name="time"
                    value={values.time}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.time && touched.time ? (
                    <p className="form-error">{errors.time}</p>
                  ) : null}
                </div>

                <div className="col-lg-4">
                  <label className="my-2">
                    Location<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput2"
                    placeholder="Please Enter Location Here"
                    name="location"
                    value={values.location}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.location && touched.location ? (
                    <p className="form-error">{errors.time}</p>
                  ) : null}
                </div>
                <div className="col-lg-4">
                  <label className="my-2">Members</label>
                  <Select
                    name="chosenMembers"
                    className="select-multiple-all-drop"
                    isMulti
                    options={values.members}
                    placeholder="Select Members"
                    onBlur={handleBlur}
                    value={values.chosenMembers}
                    onChange={(selectedMembers) => {
                      setFieldValue("chosenMembers", selectedMembers);
                    }}
                  />
                </div>
                <div className="row mt-4">
                  <div className="col-lg-8">
                    <label className="my-2">
                      {" "}
                      Description<span className="required">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Please Enter Description Here"
                      name="description"
                      id="floatingTextarea"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {errors.description && touched.description ? (
                      <p className="form-error">{errors.description}</p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="right-sidebtn-add text-end mt-5">
          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              onClick={() => {
                navigate(-1);
              }}
              className="btn btn-primary outline-btn-cls me-2"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary filled-btn-cls">
              Add
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddNewEvent;
